import React, { useEffect } from 'react';
import { LOGIN_ENABLED, MOCK_FALLBACK_ENABLED } from '@constants/auth';
import { useAuth } from '@hooks/useAuth';
import { notifyAuthErrorOnce } from '@utils/authEvents';
import './LoginView.less';

export interface AuthGateProps {
  children: React.ReactNode;
}

const AuthGate: React.FC<AuthGateProps> = ({ children }) => {
  const auth = useAuth();
  const canUseMockFallback = !LOGIN_ENABLED && MOCK_FALLBACK_ENABLED;

  useEffect(() => {
    if (auth.status === 'anonymous' && !canUseMockFallback) {
      notifyAuthErrorOnce();
    }
  }, [auth.status, canUseMockFallback]);

  if (auth.status === 'initializing') {
    return <div className="auth-gate-status" role="status">認証情報を確認しています…</div>;
  }
  if (auth.isAuthenticated) return <>{children}</>;
  if (canUseMockFallback) return <>{children}</>;

  return null;
};

export default AuthGate;
